import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Modal, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./State.css";

const AddIntrest = ({ onClose, onAddState }) => {
  const [intrestName, setIntrestName] = useState("");
  const [intrestRate, setIntrestRate] = useState("");
  const [errors, setErrors] = useState({});
  const [submitMessage, setSubmitMessage] = useState("");
  const Api = process.env.REACT_APP_API;

  const validateForm = () => {
    const newErrors = {};
    if (!intrestName) {
      newErrors.intrestName = "Intrest name is required";
    }
    if (!intrestRate) {
      newErrors.intrestRate = "Intrest code is required";
    } else if (intrestRate.length !== 2) {
      newErrors.intrestRate = "Intrest code must be 2 characters long";
    }
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      toast.error("Please fix the errors in the form");
      return;
    }
    setSubmitMessage("State added Successfully!");

    const formData = {
      intrestName,
      intrestRate,
    };

    try {
      const response = await fetch(`${Api}/api/intrest-rates`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const result = await response.json();
        console.log("Success:", result);
        toast.success("Added Successfully");
        onAddState(result);
        onClose(); // Close the popup after successful form submission
      } else {
        console.error("Error submitting form:", response.statusText);
        toast.error("Error submitting form");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Error submitting form");
    }
  };

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title"> Add Intrest </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="!#" onClick={(event) => event.preventDefault()}>
                VFC
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Add Intrest
            </li>
          </ol>
        </nav>
      </div>
      <Modal show onHide={onClose}>
        {submitMessage && <Alert variant="info">{submitMessage}</Alert>}

        <Modal.Header>
          <Modal.Title>Add Intrest</Modal.Title>
          <Button
            variant="outline-danger"
            onClick={onClose}
            style={{ marginLeft: "auto" }}
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formintrestName">
              <Form.Label>Interest Name</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Interest Name"
                  value={intrestName}
                  onChange={(e) => setIntrestName(e.target.value)}
                  isInvalid={!!errors.intrestName}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.intrestName}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group controlId="formintrestRate">
              <Form.Label>Interest Rate</Form.Label>
              <div className="input-container">
                <Form.Control
                  type="text"
                  placeholder="Enter Intrest Rate"
                  value={intrestRate}
                  onChange={(e) => setIntrestRate(e.target.value)}
                  isInvalid={!!errors.intrestRate}
                />
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.intrestRate}
              </Form.Control.Feedback>
            </Form.Group>
          </Form>
          <button
            type="submit"
            className="btn btn-outline-primary btn-icon-text mt-3"
          >
            <i className="mdi mdi-file-check btn-icon-prepend"></i>
            Submit
          </button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddIntrest;
